export default {
      id: "map-point-fill-usage",
      viewBox: "0 0 27 32",
      url: __webpack_public_path__ + "img/icons.svg#map-point-fill",
      toString: function () {
        return this.url;
      }
    }